import { Box, Card, Text, CardHeader, CardBody } from "grommet";

export default function PodAlertsCard({ organization }) {
  return (
    <Card fill height={{ min: "large" }}>
      <CardHeader
        align="center"
        justify="center"
        pad="medium"
        border={{ side: "bottom", color: "gray", size: "xsmall" }}
      >
        <Box direction="row" justify="center" align="center">
          <Text weight="bold" size="large">
            Alerts
          </Text>
        </Box>
      </CardHeader>
      <CardBody>
        <Box direction="row" justify="start" align="start" pad="medium">
          <Text
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-all",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            {organization?.agent_alerts || "No alerts"}
          </Text>
        </Box>
      </CardBody>
    </Card>
  );
}
